import styled from 'styled-components'

export const Container = styled.section(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

export const Form = styled.form(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))
